<template>
    <div class="mt-5 mr-4 ml-4 flex justify-end">
        <div 
            class='inl-block inl-24'
            v-for="(elem, ind) in filterData" :key="ind" >
            <CardFilterSelect
                :filterData="elem.data"
                :placeholder="elem.label"
                v-model="filterInVals[elem.key]"
            />
        </div>
        <div 
            style="margin-left: 5%;"
            class="inl-block inl-10">
            <button 
                style="width: 100%;"
                @click="filterPage"
                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                Обновить
            </button>

        </div>
    </div>
</template>


<script>
import CardFilterSelect from "@/components/Cards/CarfdFilterSelect.vue";

export default {
    components: {
        CardFilterSelect,
    },
    mounted() {

    },
    data() {
        return {
            filterInVals: {...this.filterVals}
        };
    },
    props: {
        filterData: {
            default: [],
        },
        page: {
            default: 1,
        },
        path: {},
        filterVals: {
            default: {},
        }
    },
    methods: {
        filterValsToQuery()  {
            let obj = {};
            for (const key in this.filterInVals) {
                let val = "";
                this.filterInVals[key].forEach(element => {
                    val += element.value + ';';
                });
                val = val.slice(0, -1);
                obj[key] = val; 
            }
            return obj;
        },
        filterPage() {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    page: this.page,
                    ...this.filterValsToQuery()
                }
            });
        }
    },
}
</script>

<style scoped>
</style>